import { render, staticRenderFns } from "./free-tools-wrapper.vue?vue&type=template&id=c8a68c04&scoped=true&"
import script from "./free-tools-wrapper.vue?vue&type=script&lang=js&"
export * from "./free-tools-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./free-tools-wrapper.vue?vue&type=style&index=0&id=c8a68c04&prod&lang=css&"
import style1 from "./free-tools-wrapper.vue?vue&type=style&index=1&id=c8a68c04&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a68c04",
  null
  
)

export default component.exports